import axios from "axios"
import baseURL, { ticketBaseURL } from "../configs/api";

export const getUsernameFromJVCRM = (username: string) => {
    return getFetchFromJVCRM(`rdRentalTenantUsers/DoesUserNameExist?userName=${username}`)
}

const getFetchFromJVCRM = (url: string, params = {}) => {
    return axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}

export const getUsername = (username: string, tenantId: string) => {
    return getFetch(`users/DoesUserNameExist?userName=${username}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId
        },
        params: params
    }).then(response => response.data);
}